import { render } from "./EventsDashboard.vue?vue&type=template&id=3c32ca49"
import script from "./EventsDashboard.vue?vue&type=script&lang=js"
export * from "./EventsDashboard.vue?vue&type=script&lang=js"

import "./EventsDashboard.vue?vue&type=style&index=0&id=3c32ca49&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__